import Image from 'next/image';

import { Box, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { Markdown } from '~/components/markdown';

export function AudienceSection({ title, text }: { title: string; text: string }) {
  return (
    <Box
      as='section'
      bgGradient='linear(to-b, white, accent.sky.100)'
      overflow='hidden'
      position='relative'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <Box
        bottom='0px'
        height='416px'
        left='50%'
        position='absolute'
        right='0px'
        top='0px'
        transform='translateX(-50%)'
        width='2000px'
        display={{
          base: 'none',
          md: 'block',
        }}
      >
        <Image
          alt=''
          sizes='2000px'
          src='/images/backgrounds/blue-lines-wide.png'
          style={{
            objectFit: 'cover',
            objectPosition: 'center bottom',
            opacity: 0.3,
            pointerEvents: 'none',
          }}
          fill
        />
      </Box>
      <ContentContainer position='relative' textAlign='center'>
        <Box margin='0 auto' maxWidth='736px'>
          {title && (
            <Heading as='h2' marginBottom='24px' size='marketing-4xl'>
              {title}
            </Heading>
          )}
          <Markdown markdownText={text} />
        </Box>
      </ContentContainer>
    </Box>
  );
}
